<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "Discount",
  components: {
    ErrorComponent,
    Alert,
    Pagination,
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      access_right: {},
      query: "",
      storeListOrigin: [],
      list: [],
      storeList: [],
      selectedStores: [],
      currentSorting: "",
      discount: {
        restricted_access: "",
        name: "",
        value: "",
        max_value: "",
        type: "",
        ignore_duplicated: false,
        force_allow_none_store: false,
      },
      decimal_separator: ".",
      precision: 0,
      currency: "",
      isAll: false,
      availableStoreStr: "",
      stores: [],
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: ""
      }
    };
  },

  mixins: [accessible],

  methods: {
    searchStores(event) {
      if(this.query == ""){
        this.storeList = this.storeListOrigin
      }else{
        this.storeList = this.$flowFilter(this.storeListOrigin, this.query);
      }
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.$api
        .getAPI({
          _action: "/discount/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }

          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_discount_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
            this.storeListOrigin = res.list;
          }
        })
        .catch(e => {});
    },
    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
    },
    checkAllStores(event) {
      this.availableStoreStr = "";
      if (this.isAll) {
        for (var i = 0; i < this.storeList.length; i++) {
          if(this.selectedStores.indexOf(this.storeList[i].id) == -1){
            this.selectedStores.push(this.storeList[i].id);
          }
        }
      }else{
        for (var i = 0; i < this.storeList.length; i++) {
          this.selectedStores = this.selectedStores.filter(item => item !== this.storeList[i].id)
        }
      }
      this.setAvailableStr();
    },

    saveDuplicatedName(e){
      this.discount.ignore_duplicated = true
      this.$refs.duplicatedItemAlert.close();
      this.save()
    },
    saveNoneCustomerStore(e){
      this.discount.force_allow_none_store = true
      this.$refs.noneCustomerStore.close();
      this.save()
    },

    setAvailableStr() {
      this.availableStoreStr = "";
      var nAvailableStore = 0;
      for(let i=0; i<this.selectedStores.length; i++){
        if(this.$_.findIndex(this.storeListOrigin, {'id': this.selectedStores[i]}) != -1){
          nAvailableStore += 1
        }
      }
      this.isAll = false
      if(nAvailableStore == this.storeListOrigin.length){
        this.isAll = true
      }
      if (this.selectedStores.length > 0) {
        if (this.isAll) {
          this.availableStoreStr = this.$lang.messages.available_in_all_stores;
        } else {
          if (nAvailableStore == 1) {
            this.availableStoreStr = `${this.$lang.messages.available_in} 1 ${this.$lang.messages.store.toLowerCase()}`;
          } else if(nAvailableStore > 0) {
            this.availableStoreStr = `${this.$lang.messages.available_in} ${nAvailableStore} ${this.$lang.messages.stores.toLowerCase()}`;
          }
        }
      }
    },

    details(id) {
      this.discount = {};
      this.selectedStores = [];
      this.$api
        .getAPI({
          _action: "/discount/detail/" + id
        })
        .then(res => {
          this.discount = res;
          if (res.stores && res.stores.length > 0) {
            for (var i = 0; i < res.stores.length; i++) {
              if (res.stores[i].is_available) this.selectedStores.push(res.stores[i].store_id);
            }
            if (this.selectedStores.length == this.storeList.length) {
              this.isAll = true;
            }
          } else {
            this.selectedStores = [];
            this.isAll = false;
          }
          this.setAvailableStr();
        });
    },

    setObj(id, name) {
      this.discount.id = id;
      this.$refs.deleteDiscountAlert.message = this.$lang.messages.delete_discount_message;
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    save() {
      if (this.selectedStores.length > 0) {
        this.discount.stores = this.selectedStores;
      } else {
        this.discount.stores = [];
      }

      if (!this.discount.value) {
        this.discount.value = 0;
      }

      this.$api
        .postAPI({
          _action: "/discount/save",
          _body: this.discount,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
          this.getList(1);
        })
        .catch(e => {
          if (e.status == 409){
              this.$refs.duplicatedItemAlert.message = e.data.message;
              $('#duplicated-customer-modal').modal('show');
            }
          if (e.status == 406){
            this.$refs.noneCustomerStore.message = e.data.message;
            $('#none-customer-store-modal').modal('show');
          }
        });
    },

    gotoDiscountEdit(id) {
      this.query = "";
      this.storeList = this.storeListOrigin;
      this.details(id);
      $("#AddDiscount").modal("show");
    },

    deleteDiscount(e) {
      if (this.discount.id) {
        this.$api
          .deleteAPI({
            _action: "/discount/delete/" + this.discount.id
          })
          .then(res => {
            this.$refs.deleteDiscountAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.discount.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteDiscountAlert.close();
          });
      }
    },

    clearAddModal(e) {
      if (!this.checkPendingAccountStatus(e)) return

      this.discount.id = "";
      this.discount.type = "PERCENTAGE";
      this.discount.name = "";
      this.discount.value = "";
      this.discount.max_value = "";
      this.discount.restricted_access = "";
      this.availableStoreStr = "";
      this.discount.stores = [];
      this.selectedStores = [];
      this.$validator.reset();
      this.errors.clear();
      this.isAll = true;
      this.checkAllStores();
    },
    retry() {
      this.getList(1);
    },
  },
  mounted() {
    this.checkAllStores();
    this.getStoreList();
    this.getList(1);

    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;

    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.access_right = payload.access_right;
      this.currentUser = payload
    });

  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-right">
              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;">
                <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                  <option value>{{$lang.messages.all_stores}}</option>
                  <option
                    v-for="store in storeList"
                    :key="store.id"
                    :value="store.id"
                  >{{store.name}}</option>
                </select>
              </div>
              <button v-if="!!access_right.menu_items"
                @click="clearAddModal"
                class="btn btn-primary px-4"
                data-toggle="modal"
                data-target="#AddDiscount"
              >+ {{$lang.messages.add_discounts}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr class="clickable-row">
                      <th scope="col">Sr.no</th>
                      <th scope="col" width="80" class="w-xs-25"></th>
                      <th scope="col">{{$lang.messages.name}}</th>
                      <th scope="col">{{$lang.messages.value}}</th>
                      <th scope="col">{{$lang.messages.max_value}}</th>
                      <th scope="col">{{$lang.messages.restricted_access}}</th>
                      <th scope="col">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(discount,i) in list" :key="discount.id">
                      <td>{{i + 1}}</td>
                      <td>
                        <i class="mdi mdi-tag font-24 text-danger"></i>
                      </td>
                      <td>{{discount.name}}</td>
                      <td
                        v-if="discount.type == 'PERCENTAGE' && !discount.value"
                      >{{$lang.messages.variable}}, %</td>
                      <td
                        v-if="discount.type == 'PERCENTAGE' && discount.value"
                      >{{discount.value}} %</td>
                      <td
                        v-else-if="discount.type == 'FIX'  && !discount.value"
                      >{{$lang.messages.variable}}, ∑</td>
                      <td v-else-if="discount.type == 'FIX'  && discount.value">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="discount.value"
                          :read-only="true"
                        />
                      </td>
                      <td
                        v-if="discount.type == 'PERCENTAGE' && discount.max_value && discount.value"
                      >
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="discount.max_value"
                          :read-only="true"
                        />
                      </td>
                      <td
                        v-else
                      ></td>
                      <td v-if="discount.restricted_access">{{$lang.messages.yes}}</td>
                      <td v-else-if="!discount.restricted_access">{{$lang.messages.no}}</td>
                      <td class="text-lg-left text-center text-nowrap">
                        <a v-if="!!access_right.menu_items"
                          @click="gotoDiscountEdit(discount.id)"
                          href="javascript:void(0)"
                          class="text-primary mr-2 font-18"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        &nbsp;&nbsp;
                        <i v-if="!!access_right.menu_items"
                          class="far fa-trash-alt font-20 text-danger"
                          data-toggle="modal"
                          data-target="#delete-discount-modal"
                          @click="setObj(discount.id, discount.name)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>
            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Box -->
    <div
      class="modal fade"
      id="AddDiscount"
      tabindex="-1"
      role="dialog"
      aria-labelledby="AddDiscount"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5
              class="modal-title font-22"
            >{{discount.id? $lang.messages.update_discount : $lang.messages.create_discount}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body form-style">
            <div class="row mb-4">
              <div class="col-lg-12 mb-4">
                <label for>{{$lang.messages.name}}</label>
                <span style="color:#ff0000">*</span>
                <input
                  name="name"
                  v-model="discount.name"
                  v-validate="'required|max:300'"
                  class="form-control"
                  maxlength="300"
                  :class="{'input': true, 'is-danger': errors.has('name') }"
                  type="text"
                  v-bind:placeholder="$lang.messages.name"
                />
                <i v-show="errors.has('name')" class="fa fa-warning"></i>
                <span
                  v-show="errors.has('name')"
                  class="help is-danger"
                >{{$lang.messages.please_enter_valid_name}}</span>
              </div>

              <div class="col-lg-12 mb-4">
                <label class="text-dark mr-3">{{$lang.messages.type}}</label>
                <div class="custom-control custom-radio d-inline-block mr-5">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="customControlValidation3"
                    v-model="discount.type"
                    name="radio-stacked"
                    value="PERCENTAGE"
                  />
                  <label
                    class="custom-control-label"
                    for="customControlValidation3"
                  >{{$lang.messages.percentage}}</label>
                </div>
                <div class="custom-control custom-radio d-inline-block">
                  <input
                    type="radio"
                    class="custom-control-input"
                    id="customControlValidation2"
                    v-model="discount.type"
                    name="radio-stacked"
                    value="FIX"
                  />
                  <label
                    class="custom-control-label"
                    for="customControlValidation2"
                  >{{$lang.messages.sum}}</label>
                </div>
              </div>

              <div class="col-lg-12 mb-lg-5 mb-4" v-if="discount.type == 'PERCENTAGE'">
                <label for>{{$lang.messages.value}}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="discount.value"
                  :id="'value'"
                  :name="'value'"
                  v-validate="'decimal|max_value:100|min_value:0'"
                />
                <p
                  class="font-14"
                >{{$lang.messages.leave_the_field_blank_to_indicate_the_value_upon_sale}}</p>

                <i v-show="errors.has('value')" class="fa fa-warning"></i>
                <span
                  v-show="errors.has('value')"
                  class="help is-danger"
                >{{$lang.messages.please_enter_valid_value}}</span>

                <label for>{{$lang.messages.max_value}}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="discount.max_value"
                  :id="'max_value'"
                  :name="'max_value'"
                  v-validate="'decimal|min_value:0'"
                />

                <i v-show="errors.has('max_value')" class="fa fa-warning"></i>
                <span
                  v-show="errors.has('max_value')"
                  class="help is-danger"
                >{{$lang.messages.please_enter_valid_value}}</span>
              </div>
              <div class="col-lg-12 mb-lg-5 mb-4" v-else>
                <label for>{{$lang.messages.value}}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="discount.value"
                  :id="'value'"
                  :name="'value'"
                  v-validate="'decimal'"
                />
                <p
                  class="font-14"
                >{{$lang.messages.leave_the_field_blank_to_indicate_the_value_upon_sale}}</p>

                <i v-show="errors.has('value')" class="fa fa-warning"></i>
                <span
                  v-show="errors.has('value')"
                  class="help is-danger"
                >{{$lang.messages.please_enter_valid_value}}</span>
              </div>

              <div class="col-lg-10 col-9">
                <h3 class="font-20">{{$lang.messages.restricted_access}}</h3>
                <label>{{$lang.messages.only_employees_with_appropriate_access_right_are_able_to_apply_this_discount}}</label>
              </div>
              <div class="col-lg-2 col-3">
                <div class="form-group">
                  <span class="switch switch-sm">
                    <input
                      type="checkbox"
                      class="switch"
                      id="switch-sm"
                      v-model="discount.restricted_access"
                    />
                    <label for="switch-sm"></label>
                  </span>
                </div>
              </div>

              <div class="col-lg-12 mb-4">
                <div class="card rounded-5 pt-1 border">
                  <div
                    class="card-header bg-white border-bottom cursor-pointer px-lg-5 px-4"
                    data-toggle="collapse"
                    data-target=".stores-list"
                    aria-expanded="true"
                    aria-controls="multiCollapseExample1 multiCollapseExample2"
                  >
                    <h4 class="font-20 d-inline">
                      {{$lang.messages.store}}
                      <span
                        class="font-16 ml-3 d-inline"
                      >{{availableStoreStr}}</span>
                    </h4>
                    <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
                  </div>
                  <div class="card-body form-style collapse stores-list px-lg-5 px-4 show">

                    <form @submit.prevent="searchStores($event)" class="mb-3">
                      <div class="input-group input-group-lg">
                        <span class="input-group-append">
                          <button class="btn btn-outline-secondary" type="submit" style="height: 40px;border-color: #c5c5c5;">
                              <i class="fa fa-search"></i>
                          </button>
                        </span>
                        <input
                            type="text"
                            class="form-control input-lg"
                            v-model="query"
                            v-on:input="searchStores($event)"
                            :placeholder="$lang.messages.search_store"/>
                      </div>
                    </form>

                    <div class="custom-control custom-checkbox" v-if="query == ''">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-1"
                        v-model="isAll"
                        @change="checkAllStores($event)"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-1"
                      >{{$lang.messages.available_in_all_stores}}</label>
                    </div>
                    <div class="dropdown-divider" style="border-top: 1px solid #c3c3c3;" v-if="query == ''"></div>
                    <div>
                      <div
                        class="custom-control custom-checkbox mb-3"
                        v-for="store in storeList"
                        :key="store.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="store.id"
                          :id="'type_'  +store.id"
                          v-model="selectedStores"
                          @change="checkUncheckStore($event)"
                        />

                        <label
                          class="custom-control-label text-dark ml-2"
                          :for="'type_' +store.id"
                        >{{store.name}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <button
              type="button"
              class="btn btn-primary mr-3"
              @click="validateForm()"
              id="save-btn"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-primary"
              id="cancel-btn"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>
    <Alert
      @rightButtonEvent="deleteDiscount($event)"
      v-bind:title="$lang.messages.delete_discount"
      ref="deleteDiscountAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-discount-modal"
    />
    <Alert
      @rightButtonEvent="saveDuplicatedName($event)"
      v-bind:title="$lang.messages.discount"
      ref="duplicatedItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="duplicated-customer-modal"
    />
    <Alert
      @rightButtonEvent="saveNoneCustomerStore($event)"
      v-bind:title="$lang.messages.discount"
      ref="noneCustomerStore"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="none-customer-store-modal"
    />
  </div>
</template>
